import './App.css';
import './Font.css';
import React, { useEffect, useState } from 'react';
import NavBar from './Components/Organisms/NavBar/index';
import Routes from './Routes';
import { Footer1 } from './Components/Organisms';
import { LoadingSpinner } from './Components/Molecules/LoadingUI';
import {
    CallFloater,
    ChatbotFloater,
    DiwaliOffer,
    ScrollToTop,
    CartFloater
} from './Components/Atoms/FixedFloater';
import Footer2 from './Components/Organisms/Footer2';
import FooterNavBar from './Components/Organisms/FooterNavBar';
import DropDownNavBar from './Components/Organisms/DropDownNavBar';
import { useAppInit } from './Hooks';
import setAuthToken from './utils/authtoken';
import Modal from './Components/Organisms/Modal';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import WebviewMenu, { WebviewModal } from './Components/Molecules/WebviewMenu';
import FilterOptions from './Components/Molecules/FilterOptions';
import CategoryBar from './Components/Molecules/CategoryBar';
import { scrollToTargetAdjusted } from './utils/ui';
import { useDispatch, useSelector } from 'react-redux';
import Onboarding from './Components/Forms/Onboarding';
import useData from './Components/Forms/Onboarding/data';
import { authActions } from './store/auth-slice';
import { setGlobalError } from './store/app-status-slice';
import AiOutlineCloseSquare from '@meronex/icons/ai/AiOutlineCloseSquare';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoginModal from './Components/LoginModal';
import { useIdleTimer } from 'react-idle-timer';
import { deleteWinnreAuthToken } from './utils/axios';
import { getConfig } from './utils/config';
import { Transition } from '@headlessui/react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { Button } from './Components/Atoms';
import CartModal from './Components/Organisms/CartModal';
import { updateCartCount } from './helpers';
import { isDealsVisible, isRewardsVisible } from './utils/routing';
import { webViewActions } from './store/webview';
import RefreshNow from './Components/Organisms/RefreshNow';
let appConfig = getConfig();

if (appConfig?.autoLogout ? sessionStorage.jwtToken : localStorage.jwtToken) {
    setAuthToken(
        appConfig?.autoLogout ? sessionStorage.jwtToken : localStorage.jwtToken
    );
}

function App() {
    const {
        loading,
        config,
        loadingWebviewToken,
        tokenLoading,
        clientWebview,
        userWebview,
        internalWebview,
        hiddenOnWebview,
        preLoginWebview,
        clientAndUserTokenLoading,
        refreshOnNoActivity,
        iframeConfig
    } = useAppInit();
    const [initiateOnboarding, setInitiateOnboarding] = useState(false);
    const [showSurvey, setShowSurvey] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    //Cart section
    const [openCartModal, setOpenCartModal] = useState(false);
    const theme = useTheme();
    const screenBelowLg = useMediaQuery(theme.breakpoints.down('lg'));
    const [isCartVisible, setIsCartVisible] = useState(false);

    const [cartCount, setCartCount] = useState(0);
    const [cartValue, setCartValue] = useState([]);
    const [isCartUpdate, setIsCartUpdate] = useState(false);
    const [smallCategories, setSmallCategories] = useState([]);
   
    const queryParams = new URLSearchParams(location.search);
    const webViewAccessToken = queryParams.get('token');
    const clientToken = queryParams.get('clientToken');
    const userToken = queryParams.get('userToken');
    const initiateRegistration = queryParams.get('initiateRegistration');
    const initiateLogin = queryParams.get('initiateLogin');
    const hideNavAndFooter =
        !!location?.pathname.includes('/redeem-voucher') ||
        !!location?.pathname.toLowerCase().includes('/bundledetails');

    const {
        unauthorizedUser,
        unauthorizedUserMessage,
        userRole,
        isAuthenticated,
        onboardingModalVisible,
        profileCompletionPercentage,
        finishedFirstTimeLoginGuide,
        isLoginModalVisible,
        showSessionTimeout
    } = useSelector((state) => state.auth);
    const { status } = useSelector((state) => state.auth.userDetails);
    const globalError = useSelector((state) => state.appStatus.globalError);
    let scrollTo = location?.state?.scrollTo;

    useEffect(() => {
        if (scrollTo) {
            scrollToTargetAdjusted(scrollTo);
        }
    }, [scrollTo]);

    useEffect(() => {
        if (initiateRegistration) {
            dispatch(authActions.openLoginModal());
        }
    }, [initiateRegistration]);

    useEffect(() => {
        if (initiateLogin) {
            dispatch(authActions.openLoginModal());
        }
    }, [initiateLogin]);

    // Mini survey Timer section
    useEffect(() => {
        const timer = setTimeout(() => {
            if (
                !internalWebview &&
                !clientWebview &&
                isAuthenticated &&
                (location.pathname === '/blogs' || location.pathname === '/')
            )
                setShowSurvey(true);
        }, 20000); // 20 seconds
        // Cleanup the timer if the component unmounts before 10 seconds
        return () => clearTimeout(timer);
    }, [isAuthenticated, location.pathname]);

    // Cart Counter

    useEffect(() => {
        // Initial count load

        // Listen for the custom 'cartUpdated' event
        // window.addEventListener('cartUpdated', updateCart());
        updateCartCount(setCartCount, setCartValue);
        window.addEventListener('cartUpdated', () => {
            setIsCartUpdate(true);
            updateCartCount(setCartCount, setCartValue);
        });

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('cartUpdated', () => {
                updateCartCount(setCartCount, setCartValue);
            });
        };
    }, []);
    useEffect(() => {
        if (window.self !== window.top && !internalWebview && !clientWebview) {
            const handleMessage = (event) => {
                const allowedOrigins = [
                    'http://localhost:3001',
                    'https://dev.loyalie.in',
                    'https://uat.loyalie.in',
                    'https://prod.loyalie.in'
                ];

                if (
                    !allowedOrigins.some((origin) =>
                        event.origin.startsWith(origin)
                    )
                ) {
                    // console.warn('❌ Blocked message from:', event.origin);
                    return;
                }

                if (typeof event.data !== 'object' || event.data === null) {
                    console.warn('❌ Invalid message payload:', event.data);
                    return;
                }

                if (event.data?.type === 'CONFIG_DATA') {
                    console.log('✅ Got CONFIG_DATA:', event.data.payload);
                    window.reloy_env.client_config_full = event.data.payload;
                    window.reloy_env.client_config =
                        event.data.payload.jsonConfig;
                    dispatch(
                        webViewActions.setIframeConfig(
                            event.data.payload.jsonConfig
                        )
                    );
                } else {
                    console.log('ℹ️ Ignored message type:', event.data?.type);
                }
            };

            window.addEventListener('message', handleMessage);

            return () => {
                window.removeEventListener('message', handleMessage);
            };
        }
    }, []);

    useEffect(() => {
        const dispatchOfflineStatus = () => {
          dispatch(setGlobalError(navigator.onLine ? null : 'offline'));
        };
      
        window.addEventListener('online', dispatchOfflineStatus);
        window.addEventListener('offline', dispatchOfflineStatus);
      
        // Initial check
        dispatchOfflineStatus();
      
        return () => {
          window.removeEventListener('online', dispatchOfflineStatus);
          window.removeEventListener('offline', dispatchOfflineStatus);
        };
      }, []);

    useEffect(() => {
        if (window.self !== window.top && !internalWebview && !clientWebview) {
            const handleMessage = (event) => {
                const allowedOrigins = [
                    'http://localhost:3001',
                    'https://dev.loyalie.in',
                    'https://uat.loyalie.in',
                    'https://prod.loyalie.in'
                ];

                if (
                    !allowedOrigins.some((origin) =>
                        event.origin.startsWith(origin)
                    )
                ) {
                    // console.warn('❌ Blocked message from:', event.origin);
                    return;
                }

                if (typeof event.data !== 'object' || event.data === null) {
                    console.warn('❌ Invalid message payload:', event.data);
                    return;
                }

                if (event.data?.type === 'CONFIG_DATA') {
                    console.log('✅ Got CONFIG_DATA:', event.data.payload);
                    window.reloy_env.client_config_full = event.data.payload;
                    window.reloy_env.client_config =
                        event.data.payload.jsonConfig;
                    dispatch(
                        webViewActions.setIframeConfig(
                            event.data.payload.jsonConfig
                        )
                    );
                } else {
                    console.log('ℹ️ Ignored message type:', event.data?.type);
                }
            };

            window.addEventListener('message', handleMessage);

            return () => {
                window.removeEventListener('message', handleMessage);
            };
        }
    }, []);

    useEffect(() => {
        const isRewardStore = location?.pathname
            ?.toLowerCase()
            ?.includes('rewardstore');
        setIsCartVisible(isRewardStore);
    }, [location.pathname]);

    // Used to open the cart if item is added.
    useEffect(() => {
        if (cartCount === 0) {
            setOpenCartModal(false);
        } else if (
            !screenBelowLg &&
            isCartUpdate &&
            location.pathname !== '/checkout'
        ) {
            setIsCartUpdate(false);
            if (isCartVisible) setOpenCartModal(true);
        }
    }, [isCartUpdate, screenBelowLg, cartCount]);

    const [showPopUp, setShowPopUp] = useState(false);
    const [openWebviewMenu, setOpenWebviewMenu] = useState(false);
    const isRegisteredCustomer =
        userRole == 'CUSTOMER' && status == 'REGISTERED';

    const logout = () => {
        if (config?.autoLogout) {
            sessionStorage.removeItem('refreshToken');
            sessionStorage.removeItem('accessToken');
            // setAuthToken(false);
            deleteWinnreAuthToken();
            window?.webengage?.track('LogOut');
            window?.webengage?.user?.logout();
            history.push('/');
            dispatch(authActions.logout());
        } else {
            if (isAuthenticated) dispatch(authActions.setSessionTimeout(true));
        }
    };

    const { getRemainingTime } = useIdleTimer({
        onIdle: logout,
        timeout: 15 * 60 * 1000 //10 minute idle timeout
    });

    // useEffect(() => {
    //     if (clientToken || webViewAccessToken) {
    //         return;
    //     }
    //     if (window.location.pathname.includes('deals')) {
    //         return;
    //     }
    //     const timer = setTimeout(() => {
    //         setShowPopUp(true);
    //     }, 1000);

    //     return () => {
    //         clearTimeout(timer);
    //     };
    // }, []);
    // const [finished, setFinished] = useState(false)

    useEffect(() => {
        if (clientToken || webViewAccessToken) {
            return;
        }
        if (
            !finishedFirstTimeLoginGuide &&
            isAuthenticated &&
            isRegisteredCustomer
        ) {
            // console.log('OPEN MODAL')
            dispatch(authActions.openOnboardingModal());
        }
    }, [finishedFirstTimeLoginGuide, isAuthenticated]);

    const changePathAndScroll = (path, scrollTo) => {
        history.push({
            pathname: path,
            state: { scrollTo: scrollTo }
        });
    };
    useEffect(() => {
        const updatedCategories = [
            {
                id: 0,
                name: 'Home',
                logo: {
                    url: 'https://cdn.loyalie.in/1691524387246_20671202.png'
                }
            }
        ];

        if (
            isDealsVisible &&
            config.clientId ===
                '89f7c75cc7d56d4969a90431f3aa0bf6dff0f21e8656455ae0068483f578584a'
        ) {
            updatedCategories.push({
                id: 1,
                name: 'Elite Offers',
                logo: {
                    url: 'https://cdn.loyalie.in/38886458.png'
                }
            });
        }

        updatedCategories.push({
            id: 2,
            name: 'Refer Now',
            logo: {
                url: 'https://cdn.loyalie.in/62332939.png'
            }
        });

        if (
            isRewardsVisible &&
            config.clientId ===
                '89f7c75cc7d56d4969a90431f3aa0bf6dff0f21e8656455ae0068483f578584a'
        ) {
            updatedCategories.push({
                id: 3,
                name: 'Referral Rewards',
                logo: {
                    url: 'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1737544977184_RewardImage'
                }
            });
        }

        updatedCategories.push({
            id: 4,
            name: 'Contact Us',
            logo: {
                url: 'https://cdn.loyalie.in/1691524657952_50456750.png'
            }
        });

        setSmallCategories(updatedCategories);
    }, [isDealsVisible, isRewardsVisible]);

    const allCategories = [
        {
            id: 0,
            name: 'Referrals',
            logo: {
                url: `${
                    config?.webview?.customIcon
                        ? config?.webview?.customIcon?.refer
                        : config?.webview?.coloredTheme
                        ? 'https://cdn.loyalie.in/56756890.png'
                        : 'https://cdn.loyalie.in/62332939.png'
                }`
            }
        },
        {
            id: 1,
            name: 'Offers',
            logo: {
                url: `${
                    config?.webview?.customIcon
                        ? config?.webview?.customIcon?.offer
                        : config?.webview?.coloredTheme
                        ? 'https://cdn.loyalie.in/80572819.png'
                        : ' https://cdn.loyalie.in/38886458.png'
                }`
            }
        },
        {
            id: 2,
            name: 'Blogs',
            logo: {
                url: `${
                    config?.webview?.customIcon
                        ? config?.webview?.customIcon?.blogs
                        : config?.webview?.coloredTheme
                        ? 'https://cdn.loyalie.in/25428662.png'
                        : 'https://cdn.loyalie.in/60309056.png'
                }`
            }
        },
        {
            id: 3,
            name: 'More',
            logo: {
                url: `${
                    config?.webview?.customIcon
                        ? config?.webview?.customIcon?.more
                        : 'https://cdn.loyalie.in/78765839.png'
                } `
            }
        }
    ];

    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    const onFilterClick = (categoryId, categoryName) => {
        switch (categoryName) {
            case 'Home':
                history.push('/');
                return;
            case 'Contact Us':
                history.push('/contact-us');
                return;
            case 'Refer Now':
            case 'Refer & Earn':
            case 'Referrals':
                if (internalWebview && isIOS) {
                    var valueToSend = {
                        type: 'OPEN_REFERRAL_IN_BROWSER'
                    };
                    window?.webkit?.messageHandlers?.jsMessageHandler.postMessage(
                        valueToSend
                    );
                } else {
                    history.push('/gift-and-earn');
                }
                return;
            case 'Track Referrals':
                changePathAndScroll('/gift-and-earn', 'pastReferrals');
                return;
            case 'More':
                setOpenWebviewMenu((prev) => !prev);
                return;
            case 'Offers':
            case 'Elite Offers':
                history.push('/deals');
                return;
            case 'Referral Rewards':
                history.push('/rewardStore');
                return;
            case 'Events':
                history.push('/events');
                return;
            case 'Blogs':
                history.push('/blogs');
                return;
            case 'Projects':
                history.push('/projects');
                return;
            default:
                history.push('/');
                return;
        }
    };
    if (unauthorizedUser && !loading) {
        return (
            <div className="h-screen flex items-center justify-center text-center">
                <p>{unauthorizedUserMessage}</p>
            </div>
        );
    }
    // console.log('RELOY CONFIG ', JSON.stringify(config));
    // console.log('from App.js', appConfig, window.reloy_env, iframeConfig);

    if (window.self !== window.top && !iframeConfig) {
        <div className="h-[100vh]">
            <LoadingSpinner
                text={'Hold on while we elevate your homeowning experience…'}
                color="text-info"
                size={16}
            />
        </div>;
    }
    return (
        <>
            {showSessionTimeout && (
                <Modal visible>
                    <div className="flex flex-col justify-center items-center">
                        <div className="text-center text-lg py-2 mb-3">
                            {
                                'Hey, are you still there?\nYour Session is about to expire!'
                            }
                        </div>
                        <Button
                            onClickFunc={() => refreshOnNoActivity()}
                            content="Click Here to Continue"
                            onClick="FUNC"
                        ></Button>
                    </div>
                </Modal>
            )}
            {(loading ||
                tokenLoading ||
                loadingWebviewToken ||
                clientAndUserTokenLoading) && (
                <div className="h-[100vh]">
                    <LoadingSpinner
                        text={
                            'Hold on while we elevate your homeowning experience…'
                        }
                        color="text-info"
                        size={16}
                    />
                </div>
            )}

            {!loading &&
                !tokenLoading &&
                !unauthorizedUser &&
                !loadingWebviewToken &&
                !clientAndUserTokenLoading && (
                    <div className="App relative">
                        {/* NavBar */}
                        {/* {!hiddenOnWebview &&
                            !hideNavAndFooter &&
                            (!window.reloy_env.client_config
                                .NAVIGATION_DROPDOWN ||
                                Object.keys(
                                    window.reloy_env.client_config
                                        .NAVIGATION_DROPDOWN
                                )?.length === 0) && (
                                <NavBar
                                    navBarConfig={config.routes}
                                    showSurvey={showSurvey}
                                />
                            )} */}
                        {!hiddenOnWebview &&
                            !hideNavAndFooter &&
                            Object.keys(
                                window.reloy_env.client_config
                                    .NAVIGATION_DROPDOWN || {}
                            ) && (
                                <DropDownNavBar
                                    navBarConfig={config.routes}
                                    showSurvey={showSurvey}
                                    cartCount={cartCount}
                                />
                            )}
                        {(clientWebview &&
                            !unauthorizedUser &&
                            !hideNavAndFooter )  && (
                                <div className="sticky bg-white top-0 z-30">
                                    <CategoryBar
                                        noScroll
                                        showArrowIndicator={false}
                                        categories={
                                            config?.webview?.smallCategories
                                                ? smallCategories
                                                : allCategories
                                        }
                                        onFilterClick={onFilterClick}
                                        scrollable={false}
                                        forClient
                                    />
                                </div>
                            )}

                        {/* Main */}
                        <Routes routesConfig={config} />
                        <ToastContainer position="top-right" />

                        {/* Footer */}
                        {config?.showFooterRoutes &&
                            !hiddenOnWebview &&
                            !hideNavAndFooter && (
                                <FooterNavBar config={config.footerRoutes} />
                            )}
                        {!hiddenOnWebview &&
                            !hideNavAndFooter &&
                            (config.footer?.layout === 'Layout1' ? (
                                <Footer1 />
                            ) : (
                                <Footer2 />
                            ))}

                        {isRewardsVisible && <CartFloater />}
                        {!hiddenOnWebview &&
                            window.reloy_env.client_config.CONTACT_DETAILS
                                ?.FLOATING_BUTTON &&
                            window.reloy_env.client_config.CONTACT_DETAILS
                                ?.FLOATER_TYPE === 'CALL' &&
                            !hideNavAndFooter && <CallFloater />}

                        {!hiddenOnWebview &&
                            window.reloy_env.client_config.CONTACT_DETAILS
                                ?.FLOATING_BUTTON &&
                            window.reloy_env.client_config.CONTACT_DETAILS
                                ?.FLOATER_TYPE === 'CHATBOT' &&
                            !hideNavAndFooter && <ChatbotFloater />}
                        {window.reloy_env.client_config.CONTACT_DETAILS
                            ?.FLOATING_BUTTON &&
                            (!window.reloy_env.client_config.CONTACT_DETAILS
                                ?.FLOATER_TYPE ||
                                window.reloy_env.client_config.CONTACT_DETAILS
                                    ?.FLOATER_TYPE === 'SCROLL_TOP') &&
                            !hideNavAndFooter && <ScrollToTop />}
                        {window.reloy_env.client_config.CONTACT_DETAILS
                            ?.FLOATING_BUTTON &&
                            (!window.reloy_env.client_config.CONTACT_DETAILS
                                ?.FLOATER_TYPE ||
                                window.reloy_env.client_config.CONTACT_DETAILS
                                    ?.FLOATER_TYPE === 'REFERRAL') &&
                            !hideNavAndFooter && <DiwaliOffer />}
                    </div>
                )}
            {/* {clientWebview && !unauthorizedUser && (
                <div
                    onClick={() => setOpenWebviewMenu((prev) => !prev)}
                    className="fixed flex items-center right-0 top-2 h-12 w-12 z-40  mx-auto"
                >
                    <FiMenu className="text-black h-full text-center w-full p-1" />
                </div>
            )} */}
            {isLoginModalVisible && !internalWebview && !preLoginWebview && (
                <LoginModal />
            )}
           

            {(openWebviewMenu && clientWebview && !unauthorizedUser) && (
                <WebviewModal
                    visible={openWebviewMenu}
                    onClick={() => {
                        setOpenWebviewMenu(false);
                    }}
                >
                    <WebviewMenu
                        onClick={() => {
                            setOpenWebviewMenu(false);
                        }}
                    />
                </WebviewModal>
            )}
            {window.reloy_env.client_config.MY_PROFILE?.ALLOW_ONBOARDING &&
                isAuthenticated &&
                onboardingModalVisible && <Onboarding />}

            {openCartModal && isCartVisible && (
                <CartModal
                    openCartModal={openCartModal}
                    setOpenCartModal={setOpenCartModal}
                    cartValue={cartValue}
                    cartCount={cartCount}
                    setCartCount={setCartCount}
                    setCartValue={setCartValue}
                    screenBelowLg={screenBelowLg}
                ></CartModal>
            )}
            {globalError && <RefreshNow errorType={globalError} />}
            
        </>
    );
}

export default App;
